import React from "react";
import ScheduleAwardsSummaryTable from "./ScheduleAwardsSummaryTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const ScheduleAwardsSummaryIndex = () => (
  <ReportProgramsPage
    TableComponent={ScheduleAwardsSummaryTable}
    loadingMessage="Loading schedule awards summary..."
  />
);

export default ScheduleAwardsSummaryIndex;
